import { z } from 'zod';
import { ASTRO_LOCALES, STRAPI_LOCALES } from '@/schemas/components/constants';

export const strapiLocale = z.enum(STRAPI_LOCALES);
export type StrapiLocale = z.infer<typeof strapiLocale>;

export const astroLocale = z.enum(ASTRO_LOCALES);
export type AstroLocale = z.infer<typeof astroLocale>;

const localizationSchema = z.object({
  documentId: z.string(),
  publishedAt: z.string().datetime({ precision: 3 }),
  locale: strapiLocale,
  slug: z.string().optional(),
});

export type Localization = z.infer<typeof localizationSchema>;
export const localizationsSchema = z.array(localizationSchema);
export type Localizations = z.infer<typeof localizationsSchema>;
